import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAddTwinDark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={38} fill="none" {...props}>
    <path
      fill="#fff"
      d="M9.996 9.62a.909.909 0 0 0-.716 1.67l5.811 2.491v5.763a.909.909 0 1 0 1.818 0V13.78l5.81-2.49a.909.909 0 0 0-.715-1.67L16 12.192zm7.961-6.656a5.45 5.45 0 0 0-3.915 0L5.025 6.433a2.73 2.73 0 0 0-1.748 2.544v12.045c0 1.128.695 2.14 1.748 2.545l9.019 3.468a5.45 5.45 0 0 0 3.915 0l9.018-3.468a2.73 2.73 0 0 0 1.748-2.545V8.977c0-1.128-.695-2.14-1.748-2.544zm-3.262 1.697a3.64 3.64 0 0 1 2.61 0l9.018 3.468a.91.91 0 0 1 .583.848v12.045a.91.91 0 0 1-.583.848l-9.018 3.469c-.84.323-1.77.323-2.61 0L5.677 21.87a.91.91 0 0 1-.583-.848V8.977c0-.376.232-.713.583-.848z"
    />
    <path
      fill="#fff"
      stroke="#0BC"
      strokeWidth={1.31}
      d="M26.345 22.363v.655h3.111a.164.164 0 0 1 0 .328h-3.111v3.111a.164.164 0 0 1-.328 0v-3.111h-3.111a.164.164 0 1 1 0-.328h3.111v-3.111a.164.164 0 0 1 .328 0zm-.164 8.843a8.024 8.024 0 1 0 0-16.049 8.024 8.024 0 0 0 0 16.05Z"
    />
  </svg>
);
export default SvgAddTwinDark;
